import { render, staticRenderFns } from "./ImageAttachment.vue?vue&type=template&id=4f10ce00&"
import script from "./ImageAttachment.vue?vue&type=script&lang=js&"
export * from "./ImageAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttachment.vue?vue&type=style&index=0&id=4f10ce00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports